import { createContext, useContext } from "react";
import { Stack, Box } from "@mui/material";
import { styleExplorer } from "qubCommon/qubStyles";
import { FlexGrid } from "@grapecity/wijmo.react.grid";
import { Popup } from "@grapecity/wijmo.react.input";
import "./bringValueModal.css";
import "@grapecity/wijmo.styles/wijmo.css";
import ButtonOk from "components/Buttons/ButtonOk";
import ButtonCancel from "components/Buttons/ButtonCancel";
import useBringValue from "./useBringValue";
import colors from "assets/scss/colors.scss";

const QubBringValueContext = createContext({});

function QubBringValueProvider({ children }) {
  const {
    gridInitialized,
    popupInitialized,
    ref,
    popupRef,
    datakey,
    setDatakey,
    title,
    setTitle,
    setSearchValue,
    setSearchField,
    setAdditionalFilter,
    setMultiSelect,
    gridData,
    setGridData,
    selectItem,
  } = useBringValue();

  async function openBringValue(props) {
    const {
      datakey,
      searchValue,
      searchField,
      additionalFilter,
      multiSelect,
      title,
      callback,
    } = props;
    ref.current = {
      callback,
    };
    setTitle(title);
    setGridData(null);
    // setDatakey(datakey);
    // setSearchValue(searchValue);
    // setSearchField(searchField);
    // setAdditionalFilter(additionalFilter);
    const result = [
      { label: "afa", value: 2 },
      { label: "12341", value: 4 },
    ];
    setGridData(result);
    popupRef.current.show(true);
    if (multiSelect) setMultiSelect(multiSelect);
  }

  return (
    <QubBringValueContext.Provider value={{ openBringValue }}>
      <Popup
        initialized={popupInitialized}
        style={{ width: "75vw", height: "90vh" }}
      >
        <Stack sx={styleExplorer.main}>
          <div
            className="wj-dialog-header Qub-DatagridBringValueView"
            style={{ backgroundColor: colors.bringValueHeader }}
          >
            <div>
              <h4 style={{ margin: 0 }}>{`Αναζήτηση σε ${datakey}`}</h4>
              <h6 style={{ marginBottom: 0, marginTop: 5 }}>{title}</h6>
            </div>
            <button
              type="button"
              style={{ height: "2vh", width: "1vw", cursor: "pointer" }}
              tabIndex={-1}
              className="close wj-hide"
            >
              &times;
            </button>
          </div>
          <Box sx={styleExplorer.content}>
            {gridData && (
              <FlexGrid
                initialized={gridInitialized}
                itemsSource={gridData}
              ></FlexGrid>
            )}
          </Box>
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginRight: 24,
              height: 25,
            }}
          >
            {`Βρέθηκαν ${gridData?.length} εγγραφές.`}
          </div>
          <Stack
            direction="row"
            justifyContent="center"
            spacing={2}
            marginBottom={2}
          >
            <ButtonCancel handleClick={() => selectItem(false)} />
            <ButtonOk handleClick={() => selectItem(true)} />
          </Stack>
        </Stack>
      </Popup>

      {children}
    </QubBringValueContext.Provider>
  );
}

function useQubBringValue() {
  const qubBringValueContext = useContext(QubBringValueContext);
  if (!qubBringValueContext) {
    throw new Error(
      "useBringValueContext must be used within a QubBringValueProvider"
    );
  }

  return qubBringValueContext;
}

export { QubBringValueProvider, useQubBringValue };
